import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { Params } from 'next/dist/shared/lib/router/utils/route-matcher'
import railsApiService from 'services/api/rails-api-service'

export interface PrepDocumentsState {
  isLoading: boolean
  documents: PrepDocument[]
  prepUserRegistryData: PrepUserRegistryData | null
}

const initialState: PrepDocumentsState = {
  isLoading: false,
  documents: [],
  prepUserRegistryData: null
}

export const prepDocumentsSlice = createSlice({
  name: 'prep-documents',
  initialState,
  reducers: {
    resetPrepDocumentsState: (state) => {
      state = initialState
      return state
    }
  },
  extraReducers: (builder) =>
    builder
      .addCase(getPrepDocuments.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getPrepDocuments.fulfilled, (state, action) => {
        state.isLoading = false
        state.documents = action.payload
      })
      .addCase(getPrepDocuments.rejected, (state) => {
        state.isLoading = false
      })
      .addCase(getPrepUserRegistryData.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getPrepUserRegistryData.fulfilled, (state, action) => {
        state.isLoading = false
        state.prepUserRegistryData = action.payload
      })
      .addCase(getPrepUserRegistryData.rejected, (state) => {
        state.isLoading = false
      })
})

export const { resetPrepDocumentsState } = prepDocumentsSlice.actions

export default prepDocumentsSlice.reducer

interface GetPrepDocumentsParams {
  user_id: number
}

export const getPrepDocuments = createAsyncThunk(
  'get-prep-documents',
  async ({ user_id }: GetPrepDocumentsParams, { rejectWithValue }) => {
    try {
      const { data } = await railsApiService.apiInstance.get(`/api/v2/prep/patients/${user_id}/index`)

      return data
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

interface GetPrepUserRegistryDataParams {
  user_id: number
}

export const getPrepUserRegistryData = createAsyncThunk(
  'get-prep-user-registry-data',
  async ({ user_id }: GetPrepUserRegistryDataParams, { rejectWithValue }) => {
    try {
      const { data } = await railsApiService.apiInstance.get<PrepUserRegistryData>(
        `/api/v2/prep/patients/${user_id}/register`
      )

      return data
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export interface PrepDocument {
  id: number
  documentType: string
  doctor: string
  date: string
  downloadUrl: string | string[] | null
  prepTreatmentLink: string | null
}

export interface PrepUserRegistryData {
  id: string | null
  createdAt: string | null
  updatedAt: string | null
  cns: string | null
  socialName: string | null
  motherFullName: string | null
  birthCountry: string | null
  nacionality: string | null
  foreignerResidence: string | null
  birthUf: string | null
  birthCity: string | null
  livingUf: string | null
  livingCity: string | null
  prefersSocialName: string | null
  isHomeless: string | null
  tradesSex: string | null
  hasDoneDrugsLast3Months: string | null
  foreignerSituation: string | null
  birthGenitalia: string | null
  sexualOrientation: string | null
  genderIdentity: string | null
  ethnicity: string | null
  scholarity: string | null
  patientId: number
  borderHabitant: boolean
  consultationId: string | null
  isIncarcerated: boolean | null
  allowsContact: boolean | null
  contactType: string | null
  contactOther: string | null
  contactAddress: string | null
  contactNeighborhood: string | null
  contactZipcode: string | null
  contactEmail: string | null
  contactPhone: string | null
  phoneType: string | null
  secondaryPhone: string | null
  secondaryPhoneType: string | null
  contactNotes: string | null
  authorizedCollectors: { name: string; document: string }[] | null
}
